import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { UxService } from '~/app/core/services';
import { WidgetBaseComponent } from '~/app/open-age/insight/components/widget.base.component';
import { CalendarEvent } from '~/app/open-age/insight/models/calendar-event.model';
import { ReportTypeService } from '~/app/open-age/insight/services/report-type.service';
import { WidgetDataService } from '~/app/open-age/insight/services/widget-data.service';
import { CalendarDateComponent } from '../calendar-date/calendar-date.component';

@Component({
  selector: 'insight-calendar-widget',
  templateUrl: './calendar-widget.component.html',
  styleUrls: ['./calendar-widget.component.css']
})
export class CalendarWidgetComponent extends WidgetBaseComponent {

  date: Date = new Date();

  events: CalendarEvent[] = [];

  selectedMonthEvents: CalendarEvent[] = [];

  @ViewChild('calendar') calendar: CalendarDateComponent;

  headArray = [];
  constructor(
    api: WidgetDataService,
    reportTypeService: ReportTypeService,
    uxService: UxService) {
    super(api, reportTypeService, uxService);

    this.afterInitialization = () => {
      this.headArray = this.reportType.columns.map((c) => c.key);
    };
    this.afterProcessing = () => {
      console.log(this.items.length);
      this.populate(this.items);
      this.monthEvents();
    };
  }

  onDateChange(date) {
    this.date = date;
    this.monthEvents();
  }

  monthEvents() {
    this.selectedMonthEvents = [];
    this.events.forEach((event) => {
      if (moment(this.date).isSame(event.date, 'month')) {
        this.selectedMonthEvents.push(event);
      }
    });
    if (this.selectedMonthEvents && this.calendar) {
      this.calendar.setEventsToCalendar(this.selectedMonthEvents);
    }
  }

  populate(list) {
    this.events = [];
    list.forEach((item) => {
      if (item.date) {
        this.events.push(new CalendarEvent({
          label: item.label,
          date: item.date,
        }));
      }
    });
  }

}
